// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__9rCGH","scroll":"Modal_scroll__1lvIQ","content":"Modal_content__MMvsn"};